(function(){
  var overlay=document.getElementById('ss-search-overlay');
  if(overlay&&overlay.parentElement!==document.body){document.body.appendChild(overlay);}
  var flyout=document.getElementById('contact-flyout');
  if(flyout&&flyout.parentElement!==document.body){document.body.appendChild(flyout);}

  var inp=document.getElementById('ss-search-input');
  var box=document.getElementById('ss-search-results');
  var inner=box?box.querySelector('[data-ss-inner]'):null;
  if(!inp||!box||!inner)return;

  box.addEventListener('click',function(e){
    var a=e.target.closest('a');
    if(a){
      overlay.style.display='none';
      box.style.display='none';
    }
  });

  var normalize=function(value){
    return String(value||'').toLowerCase().replace(/\s+/g,' ').trim();
  };

  var timer;
  inp.addEventListener('input',function(){
    clearTimeout(timer);
    var q=this.value.trim();
    if(q.length<2){box.style.display='none';inner.innerHTML='';return;}
    timer=setTimeout(function(){
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
      .then(function(r){return r.json();})
      .then(function(d){
        var prods=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        var normalizedQuery=normalize(q);
        var titleMatches=prods.filter(function(p){
          return normalize(p.title).includes(normalizedQuery);
        });
        if(titleMatches.length){prods=titleMatches;}
        if(!prods.length){box.style.display='none';inner.innerHTML='';return;}
        inner.innerHTML=prods.map(function(p){
          var imgHtml=p.image?'<img src="'+p.image+'" style="width:50px;height:50px;object-fit:cover;border-radius:3px;flex-shrink:0;">':'<div style="width:50px;height:50px;background:#f5f0ea;border-radius:3px;flex-shrink:0;"></div>';
          return '<a href="'+p.url+'" style="display:flex;align-items:center;gap:14px;padding:12px 0;border-bottom:1px solid #f0ece8;text-decoration:none;color:inherit;">'+imgHtml+'<div style="font-size:14px;font-family:Cormorant Garamond,Georgia,serif;color:#222;letter-spacing:0.02em;">'+p.title+'</div></a>';
        }).join('');
        box.style.display='block';
      })
      .catch(function(){box.style.display='none';});
    },250);
  });
  inp.addEventListener('keydown',function(e){
    if(e.key==='Escape'){box.style.display='none';inner.innerHTML='';}
  });
})();